module.exports = __webpack_public_path__ + "img/References_colorado-mountain.35a383f7.jpg";